import(/* webpackMode: "eager" */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/app/error.tsx");
